<style lang="scss" scoped>
@import '$vars';

.menu_mobile {
  @apply fixed top-0 w-full h-full bg-white overflow-auto;
  padding-top: 5rem;
  z-index: 199;
  &__header {
    figure {
      @apply flex justify-evenly  py-4 border-b;
      background: $color-gradient;
      .profile-pic {
        @apply bg-grayLight w-4/12 rounded-full;
        height: 10%;
      }
      .profile-info {
        @apply flex flex-col ml-4 text-white justify-between;
        .profile-doctor {
          @apply flex flex-col;
        }
      }
    }
  }
  &__menu {
    @apply flex flex-wrap list-none px-2 m-0 pb-8;
    li {
      @apply w-4/12 p-4 flex justify-center;
      @screen sm2 {
        @apply w-3/12;
      }
      >a {
        @apply flex relative flex-col w-full h-full m-0 justify-between items-center text-center;
        >img {
          @apply w-full absolute rounded-full border-green border-2;
          background: $color-gradient !important;
          z-index: -1;
        }
        >figure {
          @apply  w-full h-auto p-5;
          >* {
            @apply w-full;
          }
        }
        >p {
          @apply h-4 p-0 m-0 text-acqua font-bold;
          background: none
        }
        &.active {
          @apply no-underline;
          >img {
            border: 2px solid $color-acqua;
            background: white !important;
          }
          p {
            @apply font-bold text-acqua;
          }
        }
      }
    }
  }
}
</style>

<template>
  <transition :name="menuTransition">
  <div class="menu_mobile" v-if="isMobileMenuToggled">
    <div class="menu_mobile__header" :class="`figure-${getRole.toLowerCase()}`">
      <figure>
        <dr-pixel :background="profile.picture" class="profile-pic" />
        <figcaption v-if="profile.name" class="profile-info">
          <div class="profile-doctor">
            <strong class="profile-name">
              <template v-if="profile.displayName">
                {{ profile.displayName }}
              </template>
              <template v-else>
                {{ profile.name | TO_SHORT_NAME }}
              </template>
            </strong>
            <small class="profile-email">{{ $store.getters.getUser }}</small>
          </div>

          <router-link
            :to="`/${fn_IS_DOCTOR() ? 'doctor' : 'secretary'}/user`"
            @click.native="routeGuard(route)"
          >
            <button class="btn btn-md btn-white">
              Minha conta
            </button>
          </router-link>
        </figcaption>
      </figure>
    </div>
    <secretary-menu
      v-if="fn_IS_SECRETARY()"
      v-click-outside="() => toggleDoctorList = false"
      :doctor="doctor"
      :doctor-list="doctorList.filter(d => d.id !== doctor.id)"
    />
    <ul class="menu_mobile__menu">
      <li
        v-for="route of visibleRoutes"
        :key="route.name"
      >
        <a
          :class="fn_GET_PARENT_ROUTE(route, getRole) === fn_GET_PARENT_ROUTE($route, getRole) ? 'active' : ''"
          @click="routeGuard(route)"
        >
          <dr-pixel />
          <dr-icon
            :class="`TOUR_MENU_${route.name}`"
            :name="route.meta.icon"
            :fill="fn_GET_PARENT_ROUTE(route, getRole) === fn_GET_PARENT_ROUTE($route, getRole) ? 'acqua' : 'white' "
          />
          <p>{{ route.meta.title }}</p>
        </a>
      </li>

      <!-- Itens do menu popover no cabeçalho -->
      <template v-for="route of profileRoutes">
        <li
          v-if="fn_IS_DOCTOR()"
          :key="route.name"
        >
          <router-link
            :class="fn_GET_PARENT_ROUTE(route, 'Doctor') === fn_GET_PARENT_ROUTE($route, 'Doctor') ? 'active' : ''"
            :to="{name: route.name}"
            @click.native="routeGuard(route)"
          >
            <dr-pixel />
            <dr-icon
              class="route-icon"
              :name="route.meta.icon"
              :fill="fn_GET_PARENT_ROUTE(route, getRole) === fn_GET_PARENT_ROUTE($route, getRole) ? 'acqua' : 'white' "
            />
            <p>{{ route.meta.title }}</p>
          </router-link>
        </li>
      </template>

      <!-- App Integration -->
      <li v-if="showIntegrationButton">
        <router-link
          :to="{ name: 'DoctorAppIntegrationEducation' }"
          :active-class="'active'"
          @click.native="routeGuard({
            name: 'DoctorAppIntegrationEducation',
            path: '/app-integration/education'
          })"
        >
          <dr-pixel />
          <dr-icon
            class="route-icon"
            :name="'menuHealthplace'"
            :fill="$route.name.includes('AppIntegration') ? 'acqua' : 'white' "
          />
          <p>Healthplace</p>
        </router-link>
      </li>
    </ul>

    <app-integration-alert
      :show.sync="showAppIntegrationAlert"
      parent-element="app-integration__left-menu-btn"
    />

    <small class="version">
      Versão {{ version }}
    </small>
  </div>
  </transition>
</template>

<script>
import logo from '@/assets/img/logo-branco.svg'
import appIntegrationAlert from '@/components/layout/appIntegrationAlert'
import { mapGetters } from 'vuex'

export default {
  components: {
    appIntegrationAlert
  },

  props: ['doctor', 'role', 'accessRoles', 'profileRoutes', 'isMobileMenuToggled'],

  data () {
    return {
      profile: {},
      visibleRoutes: [],
      showAppIntegrationAlert: false,
      version: '0.0.0',
      loaded: false,
      windowWidth: 0,
      noOffices: false,
      menuTransition: 'fade_up',
      logo
    }
  },

  computed: {
    ...mapGetters({
      offices: 'getOffices',
      appIntegration: 'getAppIntegration'
    }),
    returnAppIntegration () {
      return this.appIntegration
    },

    showIntegrationButton () {
      return this.fn_IS_DOCTOR() &&
          this.appIntegration &&
          this.appIntegration['is_active']
    },

    getRole () {
      return this.fn_IS_DOCTOR() ? 'Doctor' : 'Secretary'
    },

    getAccessRoles () {
      return this.$store.getters.getAccessRoles
    },

    getOfficesLength () {
      return this.doctor.doctor_offices.length
    }

  },

  watch: {
    isMobileMenuToggled (next) {
      setTimeout(() => {
        this.menuTransition = next ? 'fade_down' : 'fade_up'
      }, 200)
    }
  },

  mounted () {
    this.profile = this.$store.getters.getProfile
    this.noOffices = this.doctor.doctor_offices.length === 0

    this.$http
      .get(`/version`, this.$store.getters.getAuthHeader)
      .then((res) => {
        this.version = res.data
      }).catch((err) => console.log(err))

    this.initRoles()
  },

  methods: {
    async initRoles () {
      this.loaded = false
      const facilitiesRoutes = ['DoctorReports']
      let arr = []
      for (let route of this.fn_GET_CHILD_ROUTES(this.fn_IS_DOCTOR() ? 'Doctor' : 'Secretary')) {
        if (route.meta.sidebar) {
          if (this.fn_IS_DOCTOR()) {
            for (let facilitiesRoute of facilitiesRoutes) {
              if (facilitiesRoute === route.name) {
                if (this.fn_IS_DOCTOR()) {
                  arr.push(route)
                }
              } else {
                arr.push(route)
              }
            }
          } else {
            if (this.checkRoles(route)) {
              route.params = {
                doctorId: this.doctor.id
              }
              arr.push(route)
            }
          }
        }
      }
      if (this.fn_IS_DOCTOR()) {
        this.visibleRoutes = arr
        this.fn_HIDE_PROGRESS()
        this.loaded = true
        return
      }
      for (let route of this.$router.options.routes) {
        if (route.name === 'Secretary') {
          for (let child of route.children) {
            for (let role of child.meta.accessRoles) {
              if (this.accessRoles.join().search(role) > -1) {
                this.visibleRoutes = arr
                this.fn_HIDE_PROGRESS()
                this.loaded = true
                this.$router.replace({name: child.name})
                return
              }
            }
          }
          this.$router.replace('/secretary/user')
        }
      }
    },

    routeGuard (route) {
      const routes = [
        'DoctorAgenda',
        'DoctorPatients',
        'DoctorFinances',
        'DoctorPrices',
        'DoctorReports',
        'DoctorServices',
        'DoctorUsersOfficeList',
        'DoctorAppIntegrationEducation'
      ]

      if (this.getOfficesLength === 0 && routes.indexOf(route.name) > -1) {
        this.$emit('show-action-modal', true)
        return
      }

      this.$emit('toggle-menu', true)
      this.$router.push(
        this.fn_IS_DOCTOR()
          ? { name: route.name }
          : `/secretary/doctor/${this.doctor.id}` + route.path.split('doctorId')[1]
      )
    },

    getColor (route) {
      let color = 'gray'
      if (route === this.fn_GET_PARENT_ROUTE(this.$route, (this.fn_IS_DOCTOR() ? 'Doctor' : 'Secretary'))) {
        color = 'gradient'
      }
      return color
    },

    checkRoles (r) {
      for (let accessRole of r.meta.accessRoles) {
        for (let role of this.$store.getters.getAccessRoles) {
          if (`ROLE_${accessRole}` === role) {
            return true
          }
        }
      }
    }
  }
}
</script>
